type IconProps = {
  className?: string;
};

export const NewCartIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.87511 1.87506C1.79229 1.87389 1.71007 1.88919 1.63321 1.92008C1.55636 1.95096 1.4864 1.99681 1.42742 2.05496C1.36844 2.11312 1.32161 2.18241 1.28964 2.25882C1.25767 2.33523 1.24121 2.41723 1.24121 2.50006C1.24121 2.58289 1.25767 2.66489 1.28964 2.7413C1.32161 2.81771 1.36844 2.88701 1.42742 2.94516C1.4864 3.00332 1.55636 3.04917 1.63321 3.08005C1.71007 3.11093 1.79229 3.12623 1.87511 3.12506H3.04943C3.19062 3.12506 3.30843 3.21348 3.3485 3.34967L6.01208 12.4048C6.24585 13.1997 6.98099 13.7501 7.81017 13.7501H14.6705C15.5133 13.7501 16.2574 13.1805 16.4796 12.3682L18.1031 6.41486C18.1285 6.32212 18.1321 6.22478 18.1137 6.13042C18.0953 6.03606 18.0553 5.94721 17.997 5.8708C17.9386 5.79439 17.8635 5.73246 17.7773 5.68984C17.6911 5.64722 17.5963 5.62505 17.5001 5.62506H5.32116L4.54845 2.99689H4.54723C4.3523 2.33433 3.73949 1.87506 3.04943 1.87506H1.87511ZM8.12511 15.0001C7.43449 15.0001 6.87511 15.5594 6.87511 16.2501C6.87511 16.9407 7.43449 17.5001 8.12511 17.5001C8.81574 17.5001 9.37511 16.9407 9.37511 16.2501C9.37511 15.5594 8.81574 15.0001 8.12511 15.0001ZM14.3751 15.0001C13.6845 15.0001 13.1251 15.5594 13.1251 16.2501C13.1251 16.9407 13.6845 17.5001 14.3751 17.5001C15.0657 17.5001 15.6251 16.9407 15.6251 16.2501C15.6251 15.5594 15.0657 15.0001 14.3751 15.0001Z"
      fill="currentColor"
    />
  </svg>
);
